import { render, staticRenderFns } from "./AssumptionsGrowthWidget.vue?vue&type=template&id=3b354650&scoped=true&"
import script from "./AssumptionsGrowthWidget.vue?vue&type=script&lang=js&"
export * from "./AssumptionsGrowthWidget.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsGrowthWidget.vue?vue&type=style&index=0&id=3b354650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b354650",
  null
  
)

export default component.exports